
import IsOptional from '@marketplace/components/forms/inputs/shared/is-optional.vue'
import IsRequired from '@marketplace/components/forms/inputs/shared/is-required.vue'

export default {
    name: 'InputLabel',
    components: { IsRequired, IsOptional },
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        optional: {
            type: Boolean,
            default: false,
        },
    },
}
